
import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import license from '../Actions/license';
import { getLicenseRequest, getLicenseHistoricalRequest, getBalanceRequest,getInvoiceDataRequest,saveInvoiceDataRequest } from '../Api/License';
import { startLoading, stopLoading } from '../LoadingHelper';
import { getCopy } from '../helpers';
const { types, actions } = license;
const { setLicenseData, setLicensesHistory, setBalanceData ,setInvoiceData, setFreeLicenseStatus, setOverflow } = actions;
const uuidv1 = require('uuid/v1');

const ID_CATALOG_FEATURE = "92b9a5c2-799a-4a22-9e80-19ed4194b75d";


export function* getInvoiceData() {
    const loadingId = yield call(startLoading);
    try {
        const response = yield call(getInvoiceDataRequest);
        if (response && response.status === 'success') {
            yield put(setInvoiceData(response.data));
        } else {
            message.error('Ocurrió un error al obtener los datos de facturación.', 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}
export function* saveInvoiceData({data}) {
    const loadingId = yield call(startLoading);
    try {
        const response = yield call(saveInvoiceDataRequest,data);
        if (response && response.status === 'success' && response.data !== null) {
            yield put(setInvoiceData(response.data));
            message.success('Datos de facturación guardados correctamente.', 5);
        } else {
            message.error('Ocurrió un error al guardar los datos de facturación.', 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}
export function* getLicense({data}) {
    const loadingId = yield call(startLoading);
    try {
        const response = yield call(getLicenseRequest, data);
        if (response && response.status === 'success' && response.data !== null) {
            let currentDate = new Date().toISOString();
            let fechaExpiracion = new Date(response.data.fechaExpiracion).toISOString();
            const parsedResponse = {
                licenseStatus: {
                    isValid:  currentDate <= fechaExpiracion,
                    ...response.data,
                },
            };
            yield put(setLicenseData(parsedResponse));
        } else {
            message.error('Ocurrió un error al obtener la información de la licencia', 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* getLicensesHistorical({data}) {
    const loadingId = yield call(startLoading, 'tableLicensesLoading');
    try {
        const response = yield call(getLicenseHistoricalRequest, data);
        if (response && response.status === 'success' && response.data !== null) {
            let licensePagination = addKeys(response.data);
            let parsedResponse = {
                licensePagination,
            }
            yield put(setLicensesHistory(parsedResponse));
       
            if(licensePagination.length === 1 && licensePagination[0].nombrePaquete.toLowerCase().includes('gratuito')) {               
                yield put(setFreeLicenseStatus(true));
            } else
                yield put(setFreeLicenseStatus(false));
        } else {
            message.error('Ocurrió un error al obtener la información de las licencias', 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}
const checkDownloadsOverflow = features =>{
    const downloadFeature = features.find(w=>w.idCatalogFeature === ID_CATALOG_FEATURE);
    return downloadFeature?.overflowed
}

export function* getBalance({data}) {
    const loadingId = yield call(startLoading, 'tableLicensesLoading');
    try {
        const response = yield call(getBalanceRequest, data);        
        if (response.status === 'success') {
            yield put(setBalanceData(response.data));
            yield put(setOverflow(checkDownloadsOverflow(response.data)))
        } else {
            message.error('Ocurrió un error al obtener la información de las licencias', 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

const addKeys = items => {
    let copy = getCopy(items);
    return copy.map(item=> {
        item.key = uuidv1();
        return item;
    })
}

export function* licenseSaga() {
    yield takeEvery(types.GET_LICENSE_DATA, getLicense);
    yield takeEvery(types.GET_LICENSES_HISTORICAL, getLicensesHistorical);
    yield takeEvery(types.GET_BALANCE_DATA, getBalance);
    yield takeEvery(types.SAVE_INVOICE_DATA, saveInvoiceData);
    yield takeEvery(types.GET_INVOICE_DATA, getInvoiceData);
};
